import React from "react";
import StaticPageTemplate from "../StaticPage/StaticPageTemplate";

const LiveOnlineClass = () => {
  return (
    <StaticPageTemplate
      slug="live-online-class"
      defaultTitle="Live Online Class"
      defaultFeatureImage="https://storage.googleapis.com/road-to-fe/uploads/1741110062990-466da6c8-cc9b-4dc9-8e42-6012adcc460c-liveClass.webp"
    />
  );
};

export default LiveOnlineClass;
